/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MappableField } from './MappableField';
import {
    MappableFieldFromJSON,
    MappableFieldFromJSONTyped,
    MappableFieldToJSON,
} from './MappableField';

/**
 * 
 * @export
 * @interface MappableEntity
 */
export interface MappableEntity {
    /**
     * 
     * @type {string}
     * @memberof MappableEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MappableEntity
     */
    entitySetName?: string;
    /**
     * 
     * @type {Array<MappableField>}
     * @memberof MappableEntity
     */
    fields: Array<MappableField>;
}

/**
 * Check if a given object implements the MappableEntity interface.
 */
export function instanceOfMappableEntity(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "fields" in value;

    return isInstance;
}

export function MappableEntityFromJSON(json: any): MappableEntity {
    return MappableEntityFromJSONTyped(json, false);
}

export function MappableEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): MappableEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'entitySetName': !exists(json, 'entitySetName') ? undefined : json['entitySetName'],
        'fields': ((json['fields'] as Array<any>).map(MappableFieldFromJSON)),
    };
}

export function MappableEntityToJSON(value?: MappableEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'entitySetName': value.entitySetName,
        'fields': ((value.fields as Array<any>).map(MappableFieldToJSON)),
    };
}

